module.exports = __webpack_public_path__ + "static/media/thermage_eyes_focus.9ff3c7f1.webm";